import { encode, decode } from 'js-base64';

export function parse<O = any>(str?: string | null): O {
  return (str ? JSON.parse(decode(str)) : {}) as O;
}

export function stringify<O = any>(obj: O): string {
  return obj ? encode(JSON.stringify(obj)) : '';
}
